// extracted by mini-css-extract-plugin
module.exports = {"highlight":"HighlightComponent--highlight"};